<template>
  <div class="container new-box">
    <div class="header clearfix">
      <div class="login-box">
        <span class="nav-sp">
          <img src="../../assets/images/logo1.jpg" alt="">
          <span>四川广智华荣工程项目咨询有限公司</span>
          <em class="em2">Sichuan Guangzhi Huarong Project Consulting Co., Ltd</em>
          <em>规范，专业，服务，创新</em>
        </span>
        <p class="login-iphone2" v-if="user_id==''">
          <span class="iphone-sp0"><em @click="dialogVisible = true">登录</em>/<em @click="goreg()">注册</em></span>
          <span class="iphone-sp1">咨询电话</span>
          <span class="iphone-sp2">028-61894045</span>
        </p>
        <div class="login-user" v-if="user_id!=''">
          <p class="user-p1"><a href="javascript:;" @click="gobsxt()">标书大厅</a><a href="javascript:;"
              @click="gouser()">报名的项目</a><a href="javascript:;">中标项目</a><a href="#" @click="gologinout">退出登录</a></p>
          <p class="user-p2">我的企业：四川久河工程技术有限公司</p>
          <p class="user-p3"><a href="#">咨询电话</a><a href="javascript:;">投诉建议</a><a href="#">常见问题</a><a
              href="javascript:;">标书领取</a></p>
        </div>


      </div>
      <div class="nav">
        <p class="nav-p">
          <a href="javascript:;" @click="goHome()"><span>官方首页</span> </a>
          <a href="javascript:;" @click="goqyjj()"><span>企业简介</span> </a>
          <a href="javascript:;" @click="gozbxx()"><span>招标信息</span> </a>
          <a href="javascript:;" @click="gokffw()"><span>客服服务</span></a>
          <a href="javascript:;" @click="gogsdt()"><span>公司动态</span></a>
          <a href="javascript:;" @click="gojlyd()"><span>交流园地</span></a>
          <a href="javascript:;" @click="gorczp()"><span>人才招聘</span></a>
          <a href="javascript:;" @click="gobsxt()"><span>报名系统</span></a>

        </p>
      </div>
    </div>
    <!--switch-->
    <div class="switch3 clearfix">
      <img src="../../assets/images/bssm-ban.jpg" alt="">
      <div class="search">
        <el-input   type="text" v-model="input" placeholder="请输入需要搜索的标书名称或者项目编号"></el-input>
        <el-row>
          <el-button>确认搜索</el-button>
        </el-row>
      </div>
    </div>
    <!--switch END-->
    <!--content -->
    <!--center-->
    <div class="center-bsxt clearfix">
      <div class="bsxt">
        <div class="zhuce" v-if="regnumber==1">
          <el-steps :active="regnumber" align-center>
            <el-step title="账户信息"></el-step>
            <el-step title="企业信息"></el-step>
            <el-step title="企业经办人"></el-step>
            <el-step title="注册完成"></el-step>
          </el-steps>
          <div class="zcbox">
            <el-form ref="formInline" :model="formInline" label-width="80px">
              <el-form-item label="登录名">
                <el-input v-model="formInline.user_name"></el-input>
              </el-form-item>
              <el-form-item label="密码">
                <el-input type="password" v-model="formInline.password"></el-input>
              </el-form-item>
              <el-form-item label="重复密码">
                <el-input type="password" v-model="formInline.a_password"></el-input>
              </el-form-item>
              <p class="check-p">
                <el-checkbox v-model="yhchecked">同意用户协议</el-checkbox>
              </p>
              <p class="check-p2">
                <el-button type="primary" @click="postregone()">下一步</el-button>
              </p>
            </el-form>
            <p class="px-p">温馨提示：用户名只是用来登陆系统的,若提示用户名存在,不代表公司已注册,请任意再换一个用户名</p>
          </div>
        </div>
        <div class="zhuce" v-if="regnumber==2">
          <el-steps :active="regnumber" align-center>
            <el-step title="账户信息"></el-step>
            <el-step title="企业信息"></el-step>
            <el-step title="企业经办人"></el-step>
            <el-step title="注册完成"></el-step>
          </el-steps>
          <div class="zcbox2">
            <p class="px-p2">温馨提示：请再次确认注册类型，一般都为大陆地区企业</p>
            <el-divider>基本信息请按照营业执照填写以下内容</el-divider>
            <el-form :inline="true" ref="formInline" :model="formInline" label-width="120px">
              <el-form-item label="注册类型">
                <el-radio-group v-model="formInline.type">
                  <el-radio label="1">中国大陆地区企业</el-radio>
                  <el-radio label="2">自然人</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
            <el-form ref="formInline" :model="formInline" label-width="120px">
              <el-form-item label="公司名称">
                <el-input v-model="formInline.name" placeholder="请输入公司名称"></el-input>
              </el-form-item>
              <el-form-item label="营业执照注册地">
                <el-input type="textarea" v-model="formInline.reg_address" placeholder="营业执照注册地"></el-input>
              </el-form-item>
            </el-form>
            <el-form :inline="true" ref="formInline" :model="formInline" label-width="120px">
              <el-form-item label="公司类型">
                <el-select v-model="formInline.company_type" placeholder="请选择公司类型">
                  <el-option label="办事处" value="1"></el-option>
                  <el-option label="分公司" value="2"></el-option>
                  <el-option label="有限责任公司" value="3"></el-option>
                  <el-option label="股份有限公司" value="4"></el-option>
                  <el-option label="个体工商户" value="5"></el-option>
                  <el-option label="私营独资企业" value="6"></el-option>
                  <el-option label="私营合伙企业" value="7"></el-option>
                  <el-option label="中外合资" value="8"></el-option>
                  <el-option label="外资企业" value="9"></el-option>
                  <el-option label="其他" value="10"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="社会信用代码">
                <el-input v-model="formInline.taxpayer_id" placeholder="统一社会信用代码"></el-input>
              </el-form-item>
              <el-form-item label="企业规模">
                <el-select v-model="formInline.business_scale" placeholder="请选择企业规模">
                  <el-option label="微型" value="1"></el-option>
                  <el-option label="小型" value="2"></el-option>
                  <el-option label="中型" value="3"></el-option>
                  <el-option label="大型" value="4"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="法人代表">
                <el-input v-model="formInline.legal_repre" placeholder="法人代表"></el-input>
              </el-form-item>
              <el-form-item label="法人电话">
                <el-input v-model="formInline.legal_phone" placeholder="法人电话"></el-input>
              </el-form-item>
              <el-form-item label="注册资本(万)">
                <el-input v-model="formInline.reg_capital" placeholder="注册资本"></el-input>
              </el-form-item>
              <el-form-item label="公司联系人">
                <el-input v-model="formInline.cm_linked_man" placeholder="公司联系人"></el-input>
              </el-form-item>
              <el-form-item label="公司联系人电话">
                <el-input v-model="formInline.cm_linked_man_phone" placeholder="公司联系人电话"></el-input>
              </el-form-item>
              <el-form-item label="成立日期">
                <el-date-picker v-model="formInline.estab_date" type="date" placeholder="选择日期"> </el-date-picker>
              </el-form-item>
            </el-form>
            <el-divider>开票与文件信息</el-divider>
            <div class="left-kp2">
              <el-form :inline="true" ref="formInline1" :model="formInline" label-width="120px">
                <el-form-item label="开票资料(2M内)">
                  <el-upload action="" class="upload1" :file-list="fileList1" :on-change="handleelchange1"  :auto-upload="false" list-type="picture-card">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </el-form-item>
                <span class="sp-wj" v-if="formInline.image_five.name!=undefined">{{formInline.image_five.name}}</span>
              </el-form>
            </div>
            <div class="right-kp">
              <el-form :inline="true" ref="formInline" :model="formInline" label-width="120px">
                <el-form-item label="银行账号">
                  <el-input v-model="formInline.bank_number" placeholder="银行账号"></el-input>
                </el-form-item>
                <el-form-item label="公司电话">
                  <el-input v-model="formInline.company_tel" placeholder="公司电话"></el-input>
                </el-form-item>
                <el-form-item label="银行开户行">
                  <el-input v-model="formInline.bank_account" placeholder="银行开户行"></el-input>
                </el-form-item>
                <el-form-item label="开票地址">
                  <el-input type="textarea" v-model="formInline.billing_address" placeholder="开票地址"></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div class="left-kp2">
              <el-form :inline="true" ref="formInline2" :model="formInline" label-width="120px">
                <el-form-item label="营业执照(2M内)">
                  <el-upload action="" class="upload1" :file-list="fileList2" :on-change="handleelchange2"  :auto-upload="false" list-type="picture-card">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </el-form-item>
              </el-form>
            </div>
            <div class="right-kp">
              <el-form :inline="true" ref="formInline" :model="formInline" label-width="120px">
                <el-form-item label="证件类型">
                  <el-select v-model="formInline.certificate_type" placeholder="请选择证件类型">
                    <el-option label="三合一" value="1"></el-option>
                    <el-option label="五合一" value="2"></el-option>
                    <el-option label="普通三证" value="3"></el-option>
                  </el-select>
                </el-form-item>

              </el-form>
            </div>

            <p class="check-p2">
              <el-button type="primary" class="button2" @click="gotoregone()">上一步</el-button>
              <el-button type="primary" class="button1" @click="postregtwo()">下一步</el-button>
            </p>
          </div>
        </div>
        <div class="zhuce" v-if="regnumber==3">
          <el-steps :active="regnumber" align-center>
            <el-step title="账户信息"></el-step>
            <el-step title="企业信息"></el-step>
            <el-step title="企业经办人"></el-step>
            <el-step title="注册完成"></el-step>
          </el-steps>
          <div class="zcbox2">
            <p class="px-p2">温馨提示：此联系人是您企业参与所需报名项目的联系人</p>
            <el-divider>企业经办人信息</el-divider>
            <div class="left-kp2">
              <el-form :inline="true" ref="formInline3" :model="formInline" label-width="120px">
                <el-form-item label="身份证件">
                  <el-upload action="" class="upload1" :file-list="fileList3" :on-change="handleelchange3"  :auto-upload="false" list-type="picture-card">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </el-form-item>
              </el-form>
            </div>
            <div class="right-kp3">
              <el-form :inline="true" ref="formInline" :model="formInline" label-width="120px">
                <el-form-item label="经办人姓名">
                  <el-input v-model="formInline.full_name" placeholder="企业经办人姓名"></el-input>
                </el-form-item>
                <el-form-item label="身份证号码">
                  <el-input v-model="formInline.id_card" placeholder="企业经办人身份证号码"></el-input>
                </el-form-item>
                <el-form-item label="经办人电话">
                  <el-input v-model="formInline.mobile" placeholder="企业经办人电话"></el-input>
                </el-form-item>
                <el-form-item label="经办人岗位">
                  <el-input v-model="formInline.position" placeholder="企业经办人岗位"></el-input>
                </el-form-item>
                <el-form-item label="经办人邮箱">
                  <el-input v-model="formInline.email" placeholder="企业经办人邮箱"></el-input>
                </el-form-item>
                <el-form-item label="文件邮寄地址">
                  <el-input type="textarea" v-model="formInline.address" placeholder="企业文件邮寄地址"></el-input>
                </el-form-item>
              </el-form>
            </div>

            <p class="check-p2">
              <el-button type="primary" class="button2" @click="gotoregtwo()">上一步</el-button>
              <el-button type="primary" class="button1" @click="postregthree()">提交注册</el-button>
            </p>
          </div>
        </div>

      </div>
    </div>
    <!--content END-->
    <!--footer-->
    <div class="bottom">
      <div class="bot-left">
        <p class="p1">联系广智华荣</p>
        <p>电子邮箱：406223221@qq.com</p>
        <p>总机：028-61894045</p>
        <p>领取标书开放时间为工作日的9:00至17:00 </p>
        <p>公司地址：四川省成都市金牛区金周路595号</p>
      </div>
      <div class="bot-right">
        <p class="p1"> 微信订阅号：</p>
        <p class="p2"><img src="../../assets/images/wm3.png" alt=""></p>
      </div>
    </div>
    <div class="footer">
      OPYRIGHT (©) 2022 四川广智华荣工程项目咨询有限公司 备案号：<a href="https://beian.miit.gov.cn/"  target="_blank">蜀ICP备2021003450号</a>
    </div>

    <el-dialog title="登录"  :close-on-click-modal="false"  :visible.sync="dialogVisible" width="20%">
      <p class="lg-p">
        <el-input v-model="inputName" placeholder="请输入用户名"></el-input>
      </p>
      <p class="lg-p">
        <el-input placeholder="请输入密码" v-model="inputPassword" show-password></el-input>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="postLogin">确定</el-button>
      </span>
    </el-dialog>

    </el-dialog>


  </div>
</template>

<script type="text/ecmascript-6">
  import http from '../../http.js';
  import QRCode from "qrcodejs2";
  export default {
    data() {
      return {
        visible: false,
        dialogVisible: false,
        dialogVisible2: false,
        dialogVisible3: false,
        activeName: 'first',
        activeName2: 'negg',
        activeName3: 'zcfg',
        input: "111",
        checked: false,
        inputName: "",
        inputPassword: "",
        regnumber: 1,
        yhchecked: true,
        user_id: '',
        imageUrl: '',
        formInline: {
          user_name: '',
          password: '',
          a_password: '',
          type: '1',
          name: '',
          reg_address: '',
          company_type: '',
          taxpayer_id: '',
          business_scale: '',
          legal_phone: '',
          reg_capital: '',
          cm_linked_man: '',
          cm_linked_man_phone: '',
          estab_date: '',
          bank_number: '',
          company_tel: '',
          bank_account: '',
          billing_address: '',
          legal_repre: '',
          certificate_type: '',
          image_three: '',
          image_five: '',
          full_name: '',
          mobile: '',
          email: '',
          address: '',
          position: '',
          id_card: '',
          id_card_img: '',
        },
        radio: "",
        bslistdata: "",
        bslistdata1: "",
        bslistdata2: "",
        bslistdata3: "",
        documents_id: "",
        bstextdata: "",
        bstype: "3",
        tableData: [],
        fileList1: [],
        fileList2: [],
        fileList3: [],
        multipleSelection: [],
        wechatkey: "",
        order_id: "",
        andler: "",
        orderdata: "",
        paydata: "",
      }
    },
    mounted: function() {

    },
    methods: {

      handleClose(done) {
        done();

      },

      /*注册步骤*/
      /*注册第一步提交*/
      postregone() {
        var that = this;
        var parameter = {
          user_name: this.formInline.user_name,
          password: this.formInline.password,
          a_password: this.formInline.a_password,
        };
        if (this.formInline.password != this.formInline.a_password) {
          this.$message.error('两次密码不一致');
          return;
        }
        http.post(this.conf.base_url + '/api/login/account', parameter).then(res => {
          if (res.data.code != "0") {
            this.$message.error(res.data.msg);
          } else {
            console.log(res.data.result);
            this.regnumber = 2;
          }
        }).catch(e => {
          //..
        })
      },
      gotoregone() {
        var that = this;
         this.regnumber =1;
      },
      gotoregtwo() {
        var that = this;
         this.regnumber = 2;
      },
      /*注册第二步数据提交*/
      postregtwo() {
        var that = this;
        console.log(this.formInline);

        if (this.formInline.name == '') {
          this.$message.error('公司名称不可为空');
          return;
        } else if (this.formInline.reg_address == '') {
          this.$message.error('营业执照注册地不可为空');
          return;
        } else if (this.formInline.company_type == '') {
          this.$message.error('公司类型不可为空');
          return;
        } else if (this.formInline.taxpayer_id == '') {
          this.$message.error('统一社会信用代码不可为空');
          return;
        } else if (this.formInline.business_scale == '') {
          this.$message.error('	企业规模不可为空');
          return;
        } else if (this.formInline.legal_phone == '') {
          this.$message.error('法人电话不可为空');
          return;
        } else if (this.formInline.reg_capital == '') {
          this.$message.error('	注册资本不可为空');
          return;
        } else if (this.formInline.cm_linked_man == '') {
          this.$message.error('公司联系人不可为空');
          return;
        } else if (this.formInline.cm_linked_man_phone == '') {
          this.$message.error('公司联系人电话不可为空');
          return;
        } else if (this.formInline.estab_date == '') {
          this.$message.error('成立日期不可为空');
          return;
        } else if (this.formInline.bank_number == '') {
          this.$message.error('银行账号不可为空');
          return;
        } else if (this.formInline.cm_company_tel == '') {
          this.$message.error('公司电话电话不可为空');
          return;
        } else if (this.formInline.bank_account == '') {
          this.$message.error('银行开户行不可为空');
          return;
        } else if (this.formInline.billing_address == '') {
          this.$message.error('开票地址不可为空');
          return;
        } else if (this.formInline.legal_repre == '') {
          this.$message.error('法人代表不可为空');
          return;
        } else if (this.formInline.certificate_type == '') {
          this.$message.error('证件类型不可为空');
          return;
        } else if (this.formInline.image_three == '') {
          this.$message.error('营业执照不可为空');
          return;
        } else if (this.formInline.image_five == '') {
          this.$message.error('开票资料图片不可为空');
          return;
        }

        console.log(this.formInline);
        var parameter = this.formInline;
        this.regnumber = 3;
      },

      /*注册第三步数据提交*/
      postregthree() {
        var that = this;
        console.log(this.formInline);
        if (this.formInline.full_name == '') {
          this.$message.error('企业经办人姓名不可为空');
          return;
        } else if (this.formInline.mobile == '') {
          this.$message.error('企业经办人电话不可为空');
          return;
        } else if (this.formInline.email == '') {
          this.$message.error('	企业经办人邮箱不可为空');
          return;
        } else if (this.formInline.address == '') {
          this.$message.error('企业文件邮寄地址不可为空');
          return;
        } else if (this.formInline.position == '') {
          this.$message.error('企业经办人岗位不可为空');
          return;
        } else if (this.formInline.legal_phone == '') {
          this.$message.error('法人电话不可为空');
          return;
        } else if (this.formInline.id_card == '') {
          this.$message.error('	身份证号码不可为空');
          return;
        } else if (this.formInline.id_card_img == '') {
          this.$message.error('	身份证件不可为空');
          return;
        }

        console.log(this.formInline);
        var parameter = this.formInline;
        http.post(this.conf.base_url + '/api/login/register', parameter).then(res => {
          if (res.data.code != "0") {
            this.$message.error(res.data.msg);
          } else {
            console.log(res.data.result);
            this.$message.success('注册成功');
             that.gobsxt();
          }
        }).catch(e => {
          //..
        })
      },
    // 上传营业执照图片
      handleelchange1(file, fileList1) {
          var that = this;
        console.log(file, fileList1)
        let formdata = new FormData()
        fileList1.map(item => { //fileList本来就是数组，就不用转为真数组了
          formdata.append("image", item.raw) //将每一个文件图片都加进formdata
        })
        this.$axios.post(this.conf.base_url + "/api/upload/upimg", formdata).then(res => {
          if (res.data.code != "0") {
            this.$message.error(res.data.message);
          } else {
            console.log(res.data);
            that.formInline.image_five=res.data.result;

          }
        }).catch(e => {
     
           this.$message.error("上传错误，重新上传图片");
        })

      },
      // 上传营业执照图片
      handleelchange2(file, fileList2) {
        console.log(file, fileList2)
        let formdata = new FormData()
        fileList2.map(item => { //fileList本来就是数组，就不用转为真数组了
          formdata.append("image", item.raw) //将每一个文件图片都加进formdata
        })
        this.$axios.post(this.conf.base_url + "/api/upload/upimg", formdata).then(res => {
          if (res.data.code != "0") {
             this.$message.error(res.data.message);
          } else {
            console.log(res.data);
            this.formInline.image_three=res.data.result;
          }
        }).catch(e => {
        
         this.$message.error("上传错误，重新上传图片");
        })

      },
      // 上传身份证图片3
      handleelchange3(file, fileList3) {
        console.log(file, fileList3)
        let formdata = new FormData()
        fileList3.map(item => { //fileList本来就是数组，就不用转为真数组了
          formdata.append("image", item.raw) //将每一个文件图片都加进formdata
        })
        this.$axios.post(this.conf.base_url + "/api/upload/upimg", formdata).then(res => {
          if (res.data.code != "0") {
             this.$message.error(res.data.message);
          } else {
            console.log(res.data);
            this.formInline.id_card_img=res.data.result;
          }
        }).catch(e => {
          this.$message.error(e.data.message);
        })

      },


      /*登录*/
      postLogin() {
        console.log(this.conf.base_url);

        var that = this;
        var parameter = {
          user_name: this.inputName,
          password: this.inputPassword
        }
        http.post(this.conf.base_url + '/api/login/login', parameter).then(res => {
          if (res.data.code != "0") {
           this.$message.error(res.data.msg);
          } else {
            console.log(res.data);
            sessionStorage.setItem("key", res.data.result.key);
            sessionStorage.setItem("user_id", res.data.result.user_id);
            sessionStorage.setItem("user_name", res.data.result.user_name);
            this.$router.go(0);

          }
        }).catch(e => {
          //..
        })
      },
      gologinout() {
        sessionStorage.clear();
        this.$router.go(0);
      },

      handleClick(tab, event) {
        this.bstype = 1;
        console.log(333333333);
      },

      goHome: function() {
        this.$router.push({
          path: '/index/'
        });
      },
      gogsdt: function() {
        this.$router.push({
          path: '/gsdt/'
        });
      },
      gojlyd: function() {
        this.$router.push({
          path: '/jlyd/'
        });
      },
      gokffw: function() {
        this.$router.push({
          path: '/kffw/'
        });
      },
      goqyjj: function() {
        this.$router.push({
          path: '/qyjj/'
        });
      },
      gorczp: function() {
        this.$router.push({
          path: '/rczp/'
        });
      },
      gozbxx: function() {
        this.$router.push({
          path: '/zbxx/'
        });
      },
      gobsxt: function() {
        this.$router.push({
          path: '/bsxt/'
        });
      },
      gonewstxt: function() {
        this.$router.push({
          path: '/newstxt/'
        });
      },
      gouser: function() {
        this.$router.push({
          path: '/user/'
        });
      },
      goreg: function() {
        this.$router.push({
          path: '/reg/'
        });
      },



    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/bsxt/reg.vue